const appConfig = {
  // prevent redirection if 401 is received
  whitelistUrl: [
    '/login',
    // ENH-052: guest referral pages have no session by design. A 401 here must
    // never bounce the visitor to /auth/login — that would throw away the very
    // link they were sent.
    '/client/guest/referrals/:token',
  ],
  env: process.env.NODE_ENV,
  appVersion: process.env.REACT_APP_VERSION || '1.0.0',
  apiUrl: `${process.env.REACT_APP_API_URL}`,
  // Prefer the live browser origin so self-referencing URLs (Stripe Checkout
  // return_to, etc.) auto-adapt to whatever domain the app is served from —
  // localhost, staging, production, preview/branch deploys, or custom domains.
  // Falls back to REACT_APP_URL when running outside a browser context (SSR,
  // tests, etc.) and finally to the production origin so the value never
  // resolves to the literal "undefined" or an empty string that would fail
  // backend URL validation.
  appUrl: (typeof window !== 'undefined' && window.location)
    ? window.location.origin
    : (process.env.REACT_APP_URL || 'https://reforal.com'),
  contactUsEmail: process.env.REACT_APP_CONTACT_US_EMAIL || 'support@reforal.com',
  termsAndConditions: 'https://reforal.com/terms',
  privacyPolicy: 'https://reforal.com/privacy-policy',

  pusher: {
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    authEndpoint: process.env.REACT_APP_PUSHER_AUTH_ENDPOINT,
  },

  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN,
    env: process.env.REACT_APP_ENV ?? 'local',
  },

  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  },
};

export default appConfig;
